import React from "react";
import { Stack } from "expo-router";
import Constants from "expo-constants";
import { Colors } from "@/constants/Colors";
import useWindow from "@/hooks/useWindow";

const PaymentLayout = () => {
  const { isDesktop } = useWindow();
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: {
          paddingTop: Constants.statusBarHeight,
          backgroundColor: Colors.background,
          width: isDesktop ? 600 : undefined,
          alignSelf: isDesktop ? "center" : undefined,
        },
      }}
    >
      <Stack.Screen name="register-method" options={{ headerShown: false }} />
    </Stack>
  );
};

export default PaymentLayout;
